import Vue from "vue";
import Vuetify from "vuetify/lib";
import Toast, {
  POSITION
} from "vue-toastification";
import "vue-toastification/dist/index.css";
import "vuetify/dist/vuetify.min.css";
import VueMask from "v-mask";
import colors from "vuetify/lib/util/colors";

Vue.use(VueMask);
Vue.use(Vuetify);

Vue.use(Toast, {
  timeout: 5000,
  position: POSITION.BOTTOM_RIGHT,
});

Vue.filter('currency', function (value, fallback = "") {
  if (!value) return fallback
  return new Intl.NumberFormat("th-TH", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
})


const opts = {
  theme: {
    themes: {
      light: {
        primary: "#FF9800",
        secondary: "#255D98",
        accent: colors.indigo.base,
        success: "#00C487",
        error: "#FF544A",
      },
    },
  },
};

export default new Vuetify(opts);
